import VectorLayer from "ol/layer/Vector";
import {PinReport} from "../services/ISharedFeatureState";
import VectorSource from "ol/source/Vector";

interface PointReportListBindings {
    points: PinReport[];
    activeLayerId: string|number;
    pointLayer: VectorLayer<VectorSource>;
    onSave: (data: { report: PinReport, changedProperties?: string[] }) => void;
    onDelete: (data: { report: PinReport }) => void;
    onRemove: (data: { report: PinReport }) => void;
    onDismiss: (data: { report: PinReport }) => void;
    onShare: (data: { report: PinReport }) => void;
}

export class PointReportListController implements PointReportListBindings, ng.IComponentController {
    constructor() {

    }

    activeLayerId: string|number;
    pointLayer: VectorLayer<VectorSource>;
    points: PinReport[] = [];
    onSave: (data: { report: PinReport, changedProperties?: string[] }) => void;
    onDelete: (data: { report: PinReport }) => void;
    onDismiss: (data: { report: PinReport }) => void;
    onRemove: (data: { report: PinReport }) => void;
    onShare: (data: { report: PinReport }) => void;


    $onChanges(onChangesObj: ng.IOnChangesObject): void {
        console.log(onChangesObj);
    }
}

export class PointReportList implements ng.IComponentOptions {
    controller = PointReportListController;

    bindings = {
        points: '<',
        pointLayer: '<',
        activeLayerId: '<',
        onSave: '&',
        onDelete: '&',
        onRemove: '&',
        onDismiss: '&',
        onShare: '&'
    };

    templateUrl = '/Partial/component/PointReportList';
}
